import Cookies from 'universal-cookie';
import moment from 'moment';
import { browserHistory } from 'react-router';

import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import storageHelper from '../../util/storageHelper';
import { identifyMixpanelUser, logoutMixpanelUser } from '../../util/mixpanel';

const cookies = new Cookies();

// Export Constants
export const AUTH_LOADING = 'auth_loading',
  AUTH_USER = 'auth_user',
  UNAUTH_USER = 'unauth_user',
  AUTH_ERROR = 'auth_error',
  FORGOT_PASSWORD_REQUEST = 'forgot_password_request',
  RESET_PASSWORD_REQUEST = 'reset_password_request',
  USER_HOSTS = 'hosts',
  DEFAULT = 'default';

export function handleError(err) {
  return setError(err, { log: false });
}

export function logout(url) {
  return dispatch => {
    BECaller.auth('logout', 'post', null, true).then(() => {
      dispatch({ type: UNAUTH_USER });
      storageHelper.storage().removeItem('token');
      storageHelper.storage().removeItem('displayToken');
      cookies.remove('displayToken', { path: '/' });
      cookies.remove('rlog', { path: '/' });
      browserHistory.push(BECaller.CLIENT_ROOT_URL + (url || `login`));
      logoutMixpanelUser();
    });
  };
}

export function getInfo() {
  return dispatch => {
    dispatch({ type: AUTH_LOADING, payload: true });
    return BECaller.api('account/info', 'get').then(response => {
      response.config = response.config || {};
      response.trialExpired = !response.isJiraLicense && response.status === 'trial' && moment(response.trialEnd).isSameOrBefore(moment());
      response.cancelled = response.status === 'cancelled';
      response.remote = !!cookies.get('rlog');
      dispatch({
        type: AUTH_USER,
        payload: {
          ...response,
          loaded: true
        }
      });
      

      identifyMixpanelUser(response._id, response.selectedAccount, response.app, response.plan, response.isAnnual, response.role, response.status, response.trial_end, response.email);

      return response;
    });
  };
}

export function updateConfig(config) {
  return (dispatch, getState) => {
    const { user } = getState().auth;

    identifyMixpanelUser(user._id, user.selectedAccount, user.app, user.plan, user.isAnnual, user.role, user.status, user.trial_end, user.email);

    dispatch({
      type: AUTH_USER,
      payload: {
        ...user,
        config: {
          ...user.config,
          ...config
        },
        loaded: true
      }
    });
  };
}

export function login(formFields) {
  return dispatch => {
    return BECaller.auth('login', 'post', formFields).then(
      res => {
        global.window && window.location && window.location.replace(res.url);
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getHosts() {
  return dispatch => {
    return BECaller.api('integrations/hosts', 'get').then(
      response => {
        dispatch({
          type: USER_HOSTS,
          payload: response
        });
        return Promise.resolve();
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject();
      }
    );
  };
}

export function chooseHost(hostId) {
  return dispatch => {
    return BECaller.api('integrations/host', 'post', hostId).then(
      () => {
        dispatch(
          
        );
        return Promise.resolve();
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject();
      }
    );
  };
}

export function registerUser(formFields) {
  return dispatch => {
    return BECaller.auth('register', 'post', formFields).then(
      () => {
        dispatch(
          setSuccessMessage({
            data: {
              auth: {
                msg: 'success.user.registered'
              }
            }
          })
        );
        return Promise.resolve();
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject();
      }
    );
  };
}

export function forgotPassword(formFields) {
  return dispatch => {
    return BECaller.auth('forgot', 'post', formFields).then(
      () => {
        return Promise.resolve();
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject();
      }
    );
  };
}

export function resetPassword(formFields) {
  return dispatch => {
    let url = 'reset';
    return BECaller.auth(url, 'post', formFields).then(
      () => {
        dispatch(
          setSuccessMessage({
            data: {
              auth: {
                msg: 'success.auth.passwordSuccesfullyReset'
              }
            }
          })
        );
        return Promise.resolve();
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject();
      }
    );
  };
}

export function joinAccount(acc, iid) {
  return dispatch => {
    BECaller.api('account/joinaccount', 'post', { acc, iid }).then(
      () => {
        dispatch(setSuccessMessage({
          data: {
            auth: {
              msg: 'success.request.joined'
            }
          }
        }));
        return dispatch(getInfo());
      },
      err => {
        dispatch(setError(err));
      }
    );
  }
}

export function requestAccount(acc) {
  return dispatch => {
    BECaller.api('account/requestaccount', 'post', { acc }).then(
      () => {
        dispatch(setSuccessMessage({
          data: {
            auth: {
              msg: 'success.request.requestSent'
            }
          }
        }));
        return dispatch(getInfo());
      },
      err => {
        dispatch(setError(err));
      }
    );
  }
}
